<template>
</template>
<script>
    import PreviewElement from "./PreviewElement";
    import HtmlElement from "../../components/pagesbuilder/elements/HtmlElement";

    export default {
        name: "PreviewHtmlElement",
        mixins: [PreviewElement,HtmlElement]
    }
</script>
